import { $t } from "~/i18n.js";
import React from "react";
import { Tabs } from "antd";
import { TotalTypes } from "~/components/profile/tabs/TotalTypes.jsx";
import {
  SPLRecencyTable,
  FESRecencyTable,
  FISRecencyTable,
  TMGRecencyTable,
} from "~/components/recency/index.js";
import { BISRecencyTable } from "~/components/recency/BISRecencyTable.jsx";
import { LastUpdated } from "~/components/atom/LastUpdated.jsx";
import { BadgesPanel } from "~/components/badges/BadgesPanel.jsx";

export const CardTypeTotals = ({ club, recency, profile, maxWidth }) => {
  const hasBadges =
    club?.has_badges &&
    ["dbo", "solist"].some((k) => profile.group_keys?.includes(k)) && 

    // TODO BADGES: remove test in localStorage 
    localStorage.getItem("badges") === "true";
  
  return (
    <div className="overviewFlightTab">
      <Tabs
        defaultActiveKey={recency ? "easa" : "gezagvoerder"}
        items={[
        
          hasBadges && {
            key: "badges",
            label: $t("Badges"),
            children: (
              <BadgesPanel userId={profile.id} maxHeight={maxWidth ? 230 : null} maxWidth={maxWidth} />
            ),
          },
          
          recency && recency.starts >= 0 && {
            key: "easa",
            label: $t("EASA SPL"),
            children: (
              <div style={{ maxHeight: 300, overflowY: "auto" }}>
                <SPLRecencyTable recency={recency} />
                <LastUpdated date_updated={profile.date_updated} />
              </div>
            ),
          },
          recency && recency.tmg_starts && {
            key: "easatmg",
            label: $t("EASA TMG"),
            children: (
              <div style={{ maxHeight: 300, overflowY: "auto" }}>
                <TMGRecencyTable recency={recency} />
                <LastUpdated date_updated={profile.date_updated} />
              </div>
            ),
          },
          recency && recency.bis && {
            key: "easabis",
            label: $t("UK SFCL BI(s)"),
            children: (
              <div style={{ maxHeight: 300, overflowY: "auto" }}>
                <BISRecencyTable recency={recency} />
                <LastUpdated date_updated={profile.date_updated} />
              </div>
            ),
          },
          recency && recency.fis && {
            key: "easafis",
            label: $t("EASA FI(s)"),
            children: (
              <div style={{ maxHeight: 300, overflowY: "auto" }}>
                <FISRecencyTable recency={recency} />
                <LastUpdated date_updated={profile.date_updated} />
              </div>
            ),
          },
          recency && recency.is_fes && {
            key: "easafes",
            label: $t("EASA FE(s)"),
            children: (
              <div style={{ maxHeight: 300, overflowY: "auto" }}>
                <FESRecencyTable recency={recency} />
                <LastUpdated date_updated={profile.date_updated} />
              </div>
            ),
          },
          {
            key: "vluchten",
            label: $t("Vluchten"),
            children: (
              <div style={{ maxHeight: 300, overflowY: "auto" }}>
                <TotalTypes user_id={profile?.id} />
              </div>
            ),
          },
        ].filter(Boolean)}
      />
    </div>
  );
};
